import { FeatureFlag } from '@/context/FeatureToggleContext/FeatureToggleContext';

import { AppRoutes } from '@/utils';

import { Entry } from '@/types/base';

export const getFeatureFlagWrapper =
  (featureFlag: Entry['featureFlag']): ((children: React.ReactNode) => React.ReactNode) =>
  (children: React.ReactNode): React.ReactNode => {
    if (!featureFlag) {
      return children;
    }

    return <FeatureFlag feature={featureFlag}>{children}</FeatureFlag>;
  };

export const routeMatches = ({
  currentRoute,
  basePath,
  navigationItems,
}: {
  currentRoute: string;
  basePath: Entry['basePath'];
  navigationItems?: Entry[];
}): boolean => {
  const matchesBasePath = Array.isArray(basePath)
    ? basePath.some(path => currentRoute.includes(path))
    : basePath !== undefined && currentRoute.includes(basePath);

  const matchesNavigationItems = navigationItems?.some(item =>
    currentRoute.includes(AppRoutes[item.id as keyof typeof AppRoutes]),
  );

  return matchesBasePath || !!matchesNavigationItems;
};
